import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/* Site-wide scroll handling for in-app navigation. index.js sets history.scrollRestoration to
   "manual" and only some pages reset scroll themselves, so a client-side link (for example the
   home page's product rail "Pricing" / "Start for free" buttons) used to land on the new page at
   the previous page's scroll depth.

   On every PUSH/REPLACE navigation:
     - with a #hash: scroll to that element, retrying briefly while the page renders;
     - otherwise: jump to the top.
   Back/forward (POP) is left alone. Same-page #anchor clicks that call preventDefault (the home
   page's product marks and rail shortcuts) never reach the router, so they are unaffected. */
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return undefined;
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    let timer = 0;
    const id = decodeURIComponent(hash.slice(1));
    const seek = () => {
      const el = document.getElementById(id) || document.querySelector(`[name="${CSS.escape(id)}"]`);
      if (el) {
        el.scrollIntoView({ block: "start" });
        return;
      }
      if (tries++ < 20) timer = window.setTimeout(seek, 100);
      else window.scrollTo(0, 0);
    };
    window.scrollTo(0, 0);
    seek();
    return () => window.clearTimeout(timer);
    // key changes on every navigation, so clicking the same link twice still resets.
  }, [pathname, hash, key, navType]);

  return null;
}
